import React from "react";
import { CalendarPlus } from "lucide-react";

const API = process.env.REACT_APP_BACKEND_URL;

function gcalUrl(ride) {
  if (!ride?.starts_at) return null;
  const s = new Date(ride.starts_at);
  const e = new Date(s.getTime() + 3 * 3600 * 1000);
  const f = (d) => d.toISOString().replace(/[-:]/g, "").replace(/\.\d{3}Z$/, "Z");
  const details = [ride.distance, ride.elevation && `${ride.elevation} climbing`, ride.cafe && `Coffee: ${ride.cafe}`, ride.strava_url]
    .filter(Boolean).join(" · ");
  const p = new URLSearchParams({
    action: "TEMPLATE",
    text: `GLCC · ${ride.name || "Club ride"}`,
    dates: `${f(s)}/${f(e)}`,
    details,
    location: ride.location || "",
  });
  return `https://calendar.google.com/calendar/render?${p.toString()}`;
}

// "Add to calendar" for a ride: .ics (Apple / Outlook / anything) + Google link.
export default function AddToCalendar({ ride }) {
  if (!ride?.starts_at) return null;
  const ics = `${API}/api/rides/${ride.id}/calendar.ics`;
  return (
    <div className="mt-4 flex items-center gap-2" data-testid="add-to-calendar">
      <a
        href={ics}
        download
        className="flex-1 flex items-center justify-center gap-2 rounded-xl border border-border-subtle bg-bg-secondary text-text-primary uppercase tracking-widest text-[11px] font-bold py-2.5 active:scale-[0.98]"
        data-testid="add-to-calendar-ics"
      >
        <CalendarPlus className="w-4 h-4 text-brand-accent" /> Add to calendar
      </a>
      <a
        href={gcalUrl(ride)}
        target="_blank"
        rel="noreferrer"
        className="flex-none rounded-xl border border-border-subtle bg-bg-secondary text-text-secondary uppercase tracking-widest text-[11px] font-bold px-3 py-2.5 active:scale-[0.98]"
        data-testid="add-to-calendar-google"
      >
        Google
      </a>
    </div>
  );
}
